import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { isKubernetesAvailable } from '@backstage/plugin-kubernetes';

/**
 * Replaces the stock Kubernetes entity tab with one that includes live pod logs.
 * Disable entity-content:kubernetes/kubernetes in app-config so IDs do not clash.
 */
const kubernetesWithLiveLogsContent = EntityContentBlueprint.make({
  name: 'kubernetes-with-live-logs',
  params: {
    path: '/kubernetes',
    title: 'Kubernetes',
    group: 'deployment',
    filter: isKubernetesAvailable,
    loader: () =>
      import('./KubernetesTabWithLiveLogs').then(m => (
        <m.KubernetesTabWithLiveLogs />
      )),
  },
});

export const kubernetesLiveLogsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [kubernetesWithLiveLogsContent],
});
